

import { Component, Vue, Prop} from 'vue-property-decorator';
import ChildrenSurvey from "./ChildrenSurvey.vue";

import { stepInfoType, stepResultInfoType } from "@/types/Application";
import PageBase from "../../PageBase.vue";

import { namespace } from "vuex-class";   
import "@/store/modules/application";

import { stepsAndPagesNumberInfoType } from '@/types/Application/StepsAndPages';
const applicationState = namespace("Application");

@Component({
    components:{
      ChildrenSurvey,
      PageBase
    }
})
export default class ChildrenDetailsGa extends Vue {

    @Prop({required: true})
    step!: stepInfoType

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;

    @applicationState.Action
    public UpdateStepResultData!: (newStepResultData: stepResultInfoType) => void

    currentStep =0;
    currentPage =0;
    showTable = true;
   
    childData = [];
    anyRowToBeEdited = null;
    editId = null; 
    incompleteError =  false;    
    
    public openForm(anyRowToBeEdited?) {
        this.showTable = false;
         Vue.nextTick(()=>{
            const el = document.getElementById('child-info-survey')
            if(el) el.scrollIntoView();
        })
        if(anyRowToBeEdited) {
            this.editId = anyRowToBeEdited.id;
            this.anyRowToBeEdited = anyRowToBeEdited;
        } else {
            this.anyRowToBeEdited = null;
        }
    }

    public childComponentData(value) {       
        this.showTable = value;
    }

    public populateSurveyData(childValue) {

        const currentIndexValue = this.childData?.length > 0 ? this.childData[this.childData.length - 1].id : 0;
        const id = currentIndexValue + 1;
        const newChild = { ...childValue, id };
        this.childData = [...this.childData, newChild];

        this.showTable = true; 
        this.resetChildrenRelatedPages(this.childData);
    }

    public deleteRow(rowToBeDeleted) {
       
        this.childData = this.childData.filter(data => {
            return data.id !== rowToBeDeleted;
        }); 
        this.resetChildrenRelatedPages(this.childData);
        this.surveyHasError();
    }

    public editRow(editedRow) {
        this.childData = this.childData.map(data => {
            return data.id === this.editId ? editedRow : data;
        });
        this.showTable = true;
        this.surveyHasError();
        this.resetChildrenRelatedPages(this.childData);
    }

    public onPrev() {
       Vue.prototype.$UpdateGotoPrevStepPage();
    }

    public onNext() {
        Vue.prototype.$UpdateGotoNextStepPage();
    }

    created() {

        if (this.step.result?.childrenDetailsGaSurvey) {
            this.childData = this.step.result.childrenDetailsGaSurvey.data;
        }
        
    }

    mounted(){
        Vue.nextTick(()=>this.surveyHasError());
        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;        
    }

    public surveyHasError(){
        let progress = this.childData.length==0? 50 : 100;
        this.incompleteError =  false;
        for(const child of this.childData){
            if (!child.dob || !child.currentGuardiansToChild || !child.parentsNotGuardiansExist || (child.parentsNotGuardiansExist == 'y' && (!child.parentsNotGuardians || child.parentsNotGuardians?.length == 0)) || !child.relationWithchild){            
                this.incompleteError = true;  
                progress = 50;    
                break
            }
        }        
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, false);
    }

    public isDisableNext() {
        return (this.childData?.length <= 0);
    }

    beforeDestroy() {
        this.surveyHasError();        
        this.UpdateStepResultData({step:this.step, data: {childrenDetailsGaSurvey: this.getChildrenResults()}})       
    }

    public getChildrenResults(){
        const questionResults: {name: string; value: any; title: string; inputType: string}[] =[];
        for(const child of this.childData)
        {
            questionResults.push({name:'childInfoSurvey', value: this.getChildInfo(child), title:'Child '+child.id +' Information', inputType:''})
        }
        
        return {data: this.childData, questions:questionResults, pageName:'Children Details', currentStep: this.currentStep, currentPage:this.currentPage}
    }

    public getChildInfo(child){
        const resultString = [];

        resultString.push(Vue.filter('styleTitle')("Name: ")+Vue.filter('getFullName')(child.name));
        resultString.push(Vue.filter('styleTitle')("Birthdate: ")+Vue.filter('beautify-date')(child.dob))
        const currentGuardians = child.currentGuardiansToChild.map(party=>party.name)
        resultString.push(Vue.filter('styleTitle')("Current guardians to the child: ")+currentGuardians)//TODO
        
        if (child.parentsNotGuardiansExist == 'y'){
            const currentParentsNotGuardians = child.parentsNotGuardians.map(party=>party.name)
            resultString.push(Vue.filter('styleTitle')("Parents who are not current guardians: ")+currentParentsNotGuardians)
        } else {
            resultString.push(Vue.filter('styleTitle')("Parents who are not current guardians: "))
        }

        resultString.push(Vue.filter('styleTitle')("Relationship with the child: ")+child.relationWithchild)
        
        return resultString
    }

    public resetChildrenRelatedPages(childData?) {
    
        const p = this.stPgNo.GA;

        const pages = [            
            p.CaringForChildGa,
            p.ReviewYourAnswersGA
        ]
        Vue.filter('setProgressForPages')(p._StepNo, pages,50);    

    }
}
